import { useState } from "react";
import PermissionGate from "../../../layout/PermissionGate";
import UpdateWallet from "./UpdateWallet";
import { formatDecimal } from "../../../utils/decimalFormat";

const WalletBalance = ({
  id,
  balance,
  freezedBalance,
  currency,
  setAlertConfig,
  fetchMerchantDetails,
}) => {
  const [type, setType] = useState(null);

  return (
    <>
      <div className="row g-5 g-lg-10 mt-4">
        {/*begin::Col*/}
        <div className="col p-0 mb-xl-10">
          <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">Wallet</h1>
          {/*begin::Tables Widget 3*/}
          <PermissionGate required={`view_merchant_wallet_balance`}>
            <div className="card">
              {/*begin::Body*/}
              <div className="text-center h1 fw-bolder pt-10">
                {formatDecimal(balance)} {currency}
              </div>
              <div className="text-center h5 fw-bolder pb-10">
                Amount on Hold: {formatDecimal(freezedBalance)} {currency}
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-center gap-2">
                  <PermissionGate
                    required={`topup_merchant_wallet_balance`}
                    fallback={<></>}
                  >
                    <button
                      onClick={() => {
                        setType("topup");
                      }}
                      className="btn btn-success"
                    >
                      <i className="bi-duotone bi-plus-circle mb-1 d-none d-md-inline"></i>
                      Topup Wallet Balance
                    </button>
                  </PermissionGate>
                  <PermissionGate
                    required={`deduct_merchant_wallet_balance`}
                    fallback={<></>}
                  >
                    <button
                      onClick={() => {
                        setType("deduct");
                      }}
                      className="btn btn-danger"
                    >
                      <i className="bi-duotone bi-dash-circle mb-1 d-none d-md-inline"></i>
                      Deduct Wallet Balance
                    </button>
                  </PermissionGate>
                </div>
              </div>
              {/*begin::Body*/}
            </div>
          </PermissionGate>
          {/*end::Tables Widget 3*/}
        </div>
        {/*end::Col*/}
      </div>
      <UpdateWallet
        id={id}
        type={type}
        setType={setType}
        setAlertConfig={setAlertConfig}
        fetchMerchantDetails={fetchMerchantDetails}
      />
    </>
  );
};

export default WalletBalance;
